import "../../../index89.css";
import { jsx as r, jsxs as m, Fragment as T } from "react/jsx-runtime";
import p from "react";
import { CloseFillIcon as x, CheckFillIcon as E } from "@ifrc-go/icons";
import { _ as B } from "../../../cs-piwRuCFZ.js";
import "../../../type-BFTbooL7.js";
import F from "../../RawButton/index.js";
import { TabContext as S } from "../TabContext.js";
import W from "../../../hooks/useTranslation.js";
const j = "common", w = {
  buttonTitleTab: "Tab"
}, A = {
  namespace: j,
  strings: w
}, I = "_tab_12kk2_1", P = "_dummy_12kk2_12", R = "_children-wrapper_12kk2_18", q = "_vertical-compact_12kk2_26", z = "_vertical_12kk2_26", D = "_active_12kk2_35", G = "_primary_12kk2_48", H = "_step_12kk2_75", J = "_visual-elements_12kk2_85", K = "_step-circle_12kk2_90", L = "_inner-circle_12kk2_98", M = "_icon_12kk2_108", O = "_progress-bar-end_12kk2_115", Q = "_progress-bar-start_12kk2_116", U = "_errored_12kk2_128", V = "_completed_12kk2_154", X = "_secondary_12kk2_183", Y = "_tertiary_12kk2_193", Z = "_disabled_12kk2_205", e = {
  tab: I,
  dummy: P,
  childrenWrapper: R,
  verticalCompact: q,
  vertical: z,
  active: D,
  primary: G,
  step: H,
  visualElements: J,
  stepCircle: K,
  innerCircle: L,
  icon: M,
  progressBarEnd: O,
  progressBarStart: Q,
  errored: U,
  completed: V,
  secondary: X,
  tertiary: Y,
  disabled: Z
};
function ne(b) {
  const a = p.useContext(S), y = W(A), {
    variant: t,
    disabled: u,
    registerTab: d,
    unregisterTab: _,
    setStep: c,
    step: C
  } = a, {
    className: f,
    name: s,
    step: i = 0,
    disabled: g,
    children: o,
    errored: n,
    ...h
  } = b;
  p.useEffect(() => (d(s), () => {
    _(s);
  }), [d, _, s]);
  const l = a.activeTab === s;
  p.useEffect(() => {
    l && c && c(i);
  }, [l, c, i]);
  const k = C > i, N = /* @__PURE__ */ m(T, { children: [
    t === "step" && /* @__PURE__ */ m("div", { className: e.visualElements, children: [
      /* @__PURE__ */ r("div", { className: e.progressBarStart }),
      /* @__PURE__ */ r("div", { className: e.stepCircle, children: /* @__PURE__ */ m("div", { className: e.innerCircle, children: [
        n && /* @__PURE__ */ r(x, { className: e.icon }),
        !n && k && /* @__PURE__ */ r(E, { className: e.icon })
      ] }) }),
      /* @__PURE__ */ r("div", { className: e.progressBarEnd })
    ] }),
    t === "primary" && /* @__PURE__ */ r("div", { className: e.dummy }),
    /* @__PURE__ */ r("div", { className: e.childrenWrapper, children: o }),
    t === "primary" && /* @__PURE__ */ r("div", { className: e.dummy })
  ] }), v = u || g;
  return /* @__PURE__ */ r(
    F,
    {
      className: B(
        e.tab,
        l && e.active,
        v && e.disabled,
        t === "primary" && e.primary,
        t === "secondary" && e.secondary,
        t === "tertiary" && e.tertiary,
        t === "step" && e.step,
        t === "vertical" && e.vertical,
        t === "vertical-compact" && e.verticalCompact,
        k && e.completed,
        n && e.errored,
        f
      ),
      onClick: a.setActiveTab,
      name: s,
      disabled: v,
      type: "button",
      title: typeof o == "string" ? o : y.buttonTitleTab,
      ...h,
      children: N
    }
  );
}
export {
  ne as default
};
